import React, { useState } from "react";
import TeamService from "services/TeamService";
import Loader from "components/Loader";
import * as moment from "moment";
import SlideShowResponsesPopper from "./SlideShowResponsesPopper";
import * as timelineActions from "reteamStore/actions";
import { useDispatch } from "react-redux";
import LazyLoadImage from "components/LazyLoadImage";

const styles = {
  slideShow: {
    marginTop: "10px",
    margin: "5px",
  },
  image: {
    width: "100%",
    background: "#ccc",
    height: "120px",
    objectFit: "cover",
  },
  timeFilter: {
    height: "35px",
  },
  slideShowHeader: {
    display: "flex",
    padding: "6px",
  },
  slideShowFooter: {
    display: "flex",
    padding: "5px",
    flexDirection: "column",
    fontSize: "12px",
    position: "relative",
  },
  publishedContainer: {
    display: "flex",
    flexDirection: "column",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  publishButton: {
    backgroundColor: "transparent",
    cursor: "pointer",
    width: "60px",
    margin: "5px",
    border: "1px solid #575f6b80",
    borderRadius: "5px",
    display: "flex",
    justifyContent: "center",
  },
};

export default ({ slideShow }) => {
  const classes = styles;
  const [publish, setPublish] = useState(slideShow?.published);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const publishSlideShow = async (slideShow) => {
    try {
      setLoading(true);

      await TeamService.publishSlideShow(slideShow.id, slideShow.team_id);

      const slideShowCopy = { ...slideShow };
      slideShowCopy.published = true;

      slideShowCopy.is_responded = true;

      slideShowCopy.published_at = new Date();

      dispatch(timelineActions.publishPost(slideShowCopy));

      setLoading(false);
      setPublish(true);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div style={classes.slideShow} key={slideShow.id} className="sidebar-post">
      <div style={classes.cardHeader}>
        {!loading && !publish && !slideShow?.published_at && (
          <div
            style={classes.publishButton}
            onClick={publishSlideShow.bind(this, slideShow)}
          >
            <abbr title="Publish" style={{ height: "25px", color: "#575f6b" }}>
              <span className="material-icons" style={{ cursor: "pointer" }}>
                send
              </span>
            </abbr>
          </div>
        )}
        {loading && !publish && (
          <div style={classes.publishButton}>
            <Loader width={20} height={20} />
          </div>
        )}
      </div>
      <LazyLoadImage
        alt={`${slideShow?.media}`}
        key={`${slideShow?.media}`}
        style={classes.image}
        image={slideShow?.media}
        imageWrapperClassName="slideshow-stats-img"
      />
      <div
        style={classes.slideShowFooter}
        className="sidebar-post-content p-3 m-1"
      >
        <h6>
          {slideShow?.published_at || publish === true
            ? "Published"
            : "Not Published"}
        </h6>
        <div className="color-light fs-12">
          {slideShow?.published_at
            ? moment(slideShow.published_at).format("DD/MM/YYYY HH:mm")
            : ""}
          {publish &&
            !slideShow?.published &&
            moment().format("DD/MM/YYYY HH:mm")}
        </div>
        <p>{slideShow?.topic}</p>
        <div>
          <SlideShowResponsesPopper slideShow={slideShow} publish={publish} />
        </div>
      </div>
    </div>
  );
};
